// removed by extract-text-webpack-plugin
module.exports = {"footer-partner":"footer-partner___B_6AY center___2iqBf","footer-partner__img":"footer-partner__img___2EYuD"};